import { render, staticRenderFns } from "./YearSlider2.vue?vue&type=template&id=1c03166b&"
import script from "./YearSlider2.vue?vue&type=script&lang=js&"
export * from "./YearSlider2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports